import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class UploadDetailesDto {


    // @ApiProperty()
    // @IsNumber()
    // employeeLeavesId: number;

    @ApiProperty()
    @MaxLength(12, { message: "Employee Code allows maximum 12 characters" })
    @IsNotEmpty({ message: "Employee Code should not be empty" })
    @IsString()
    @IsAlphanumeric()
    @IsOptional()
    employeeCode: string;

    @ApiProperty()
    @MaxLength(50, { message: "Employee Name allows maximum 30 characters" })
    @IsNotEmpty()
    @IsString()
    @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"), { message: "Employee name should be only alpha numeric" })
    employeeName: string;

    @ApiProperty()
    @IsString()
    gender: string;

    @ApiProperty()
    @MaxLength(20)
    @IsNotEmpty()
    @IsString()
    designation: string;

    @ApiProperty()
    @MaxLength(20)
    @IsString()
    department: string;

    @ApiProperty()
    @MaxLength(20)
    @IsString()
    priorityOne: string;

    @ApiProperty()
    @MaxLength(20)
    @IsString()
    priorityTwo: string;

    @ApiProperty()
    @MaxLength(20)
    @IsString()
    employeeStatus: string;

    
    @ApiProperty()
    @IsNumber()
    yearOfExperience: Number;
    
    @ApiProperty()
    @IsString()
    emailId: string;

    @ApiProperty()
    @IsString()
    @IsNotEmpty()
    @MaxLength(10, { message: "Mobile number allows 10 characters only. " })
    mobileNumber: string;

}

